<template>
    <BreadCrumb PageTitle="Point du Stock" />
    <Stock />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Stock from "../../components/Produit/Stock.vue";

    export default defineComponent({
        name: "StockPage",
        components: {
            BreadCrumb,
            Stock,
        },
    });
</script>